var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/username.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/username.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n";
env.getTemplate("modal/modal-contents.j2", true, "core/templates/modal/username.j2", false, function(t_9,_parentTemplate) {
if(t_9) { cb(t_9); return; }
parentTemplate = _parentTemplate
for(var t_8 in parentTemplate.blocks) {
context.addBlock(t_8, parentTemplate.blocks[t_8]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
output += t_12;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    o-modal--small\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n<form novalidate data-parsley-validate id=\"user-name\" class=\"js-username ";
output += runtime.suppressValue((lineno = 10, colno = 83, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"username")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <h1 class=\"c-modal-username__h1\">\n                ";
output += runtime.suppressValue((lineno = 17, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["username_header"])), env.opts.autoescape);
output += "\n            </h1>\n\n            ";
output += runtime.suppressValue((lineno = 20, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayGeneralErrors"), "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"generalErrors"),runtime.makeKeywordArgs({"class": "c-form-block"})])), env.opts.autoescape);
output += "\n\n            <p class=\"c-modal-username__p\">\n                ";
output += runtime.suppressValue((lineno = 23, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["username_instructional"])), env.opts.autoescape);
output += "\n            </p>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <div class=\"c-form__field c-form__field--required ";
output += runtime.suppressValue((lineno = 34, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"username")])), env.opts.autoescape);
output += "\">\n                <label for=\"user_name\" class=\"c-modal-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 36, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["username_form-username"])), env.opts.autoescape);
output += "\n                </label>\n\n                <input type=\"username\" id=\"login-username\" name=\"username\"\n                    class=\"c-form__text ";
output += runtime.suppressValue((lineno = 40, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"username")])), env.opts.autoescape);
output += "\"\n                    data-parsley-pattern=\"[a-zA-Z0-9_]*\"\n                    data-parsley-pattern-message=\"ERROR_USERNAME_MODAL_INVALID_USERNAME\"\n                    data-parsley-minlength=\"3\"\n                    data-parsley-minlength-message=\"ERROR_USERNAME_MODAL_MIN_LENGTH_VALIDATION_ERROR\"\n                    maxlength=\"16\"\n                    data-qa-create-username\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += runtime.suppressValue((lineno = 48, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedField"), "validatedField", context, ["USERNAME_MODAL_VALIDATION_ERROR",runtime.makeKeywordArgs({"field": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"username")})])), env.opts.autoescape);
;
}
output += "\n                    aria-describedby=\"login-username_error\"\n                />\n\n                ";
output += runtime.suppressValue((lineno = 53, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"userName")),"messages")),"username"),runtime.makeKeywordArgs({"id": "login-username"})])), env.opts.autoescape);
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <div class=\"g-modal-login__submit\">\n\n              <button type=\"submit\" class=\"c-button-primary c-button-primary--full\" data-qa-username-submit>\n                  ";
output += runtime.suppressValue((lineno = 68, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-username_submit"])), env.opts.autoescape);
output += "\n              </button>\n\n            </div>\n\n            <div class=\"g-modal-login__cancel\">\n\n                <div class=\"c-modal-form__field c-modal-login__button-cancel\">\n\n                    <button class=\"c-button-text c-modal-form__cancel js-modal__cancel\" data-qa-username-close>\n                        ";
output += runtime.suppressValue((lineno = 78, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-username_cancel"])), env.opts.autoescape);
output += "\n                    </button>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</form>\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/username.j2"] , dependencies)